import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '@hooks/useRedux';

interface RequireRoleProps {
  role: 'admin' | 'client';
}

/**
 * Guard de rôle : redirige si l'utilisateur n'a pas le rôle requis.
 */
export function RequireRole({ role }: RequireRoleProps) {
  const user = useAppSelector((s) => s.auth.user);

  if (!user || user.role !== role) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
